import { SearchActivitiesDocument } from '../generated/types'
import type { NoteActivity, SearchActivitiesQuery } from '../generated/types'
import type ApolloCache from '@wora/apollo-cache'
import { updateQueries } from './util'
import type { CacheProxy } from '.'

/**
 * Updates any cached Notes in the apollo cache
 */
export function updateCachedNote(proxy: CacheProxy, note: NoteActivity) {
  const cache = proxy as ApolloCache

  // update all searchActivities queries to remove the note, or update it if existing, or add if missing
  if (note._deleted) {
    updateQueries<SearchActivitiesQuery>(cache, {
      query: SearchActivitiesDocument,
      update: (data) => {
        const filteredNotes = data.searchActivities.activities.filter((q) => q._id !== note._id)

        return {
          ...data,
          searchActivities: {
            ...data.searchActivities,
            activities: filteredNotes,
            total_rows:
              filteredNotes.length !== data.searchActivities.activities.length
                ? data.searchActivities.total_rows - 1
                : data.searchActivities.total_rows
          }
        }
      }
    })
  } else {
    // update the new acitvity in the search if fuond, else add it to results
    updateQueries<SearchActivitiesQuery>(cache, {
      query: SearchActivitiesDocument,
      update: (data) => {
        const existingIndex = data.searchActivities.activities.findIndex((q) => q._id === note._id)
        let newActivities = data.searchActivities.activities.slice()
        if (existingIndex >= 0) {
          newActivities[existingIndex] = note
        } else {
          newActivities = [note, ...newActivities]
        }

        return {
          ...data,
          searchActivities: {
            ...data.searchActivities,
            activities: newActivities,
            total_rows: existingIndex < 0 ? data.searchActivities.total_rows + 1 : data.searchActivities.total_rows
          }
        }
      }
    })
  }
}
